import type { IconButtonProps } from '@mui/material/IconButton';

import { useState } from 'react';
import { m } from 'framer-motion';
import { usePopover } from 'minimal-shared/hooks';

import Badge from '@mui/material/Badge';
import { Tooltip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { fToNow } from 'src/utils/format-time';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';
import { Scrollbar } from 'src/components/scrollbar';
import { CustomPopover } from 'src/components/custom-popover';
import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export type ContactsPopoverProps = IconButtonProps & {
  data?: {
    id: string;
    role: string;
    name: string;
    email: string;
    status: string;
    address: string;
    avatarUrl: string;
    phoneNumber: string;
    lastActivity: string;
  }[];
};

export function ChatAssignedTo({ data = [], sx, ...other }: ContactsPopoverProps) {
  const { open, anchorEl, onClose, onOpen } = usePopover();

  const { t } = useTranslate('translation');
  const [selectedContactId, setSelectedContactId] = useState<string[] | null>(null);

  const handleSelectContact = (id: string) => {
    setSelectedContactId((prev) => {
      if (prev === null) {
        return [id];
      }
      if (prev.includes(id)) {
        return prev.filter((contactId) => contactId !== id);
      }
      return [...prev, id];
    });
  };
  const router = useRouter();

  const handleButtonClick = () => {
    router.replace(paths.setting.user.root);
  };

  const renderMenuList = () => (
    <CustomPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{ arrow: { offset: 20 } }}
    >
      <Scrollbar sx={{ height: 320, width: 320 }}>
        {data.map((contact) => (
          <MenuItem
            key={contact.id}
            sx={{
              p: 1,
              bgcolor: selectedContactId?.includes(contact.id) ? 'action.selected' : 'inherit',
            }}
            onClick={() => handleSelectContact(contact.id)}
          >
            <Badge badgeContent="">
              <Avatar alt={contact.name} src={contact.avatarUrl} />
            </Badge>

            <ListItemText
              primary={contact.name}
              secondary={contact.status === 'offline' ? fToNow(contact.lastActivity) : ''}
              slotProps={{
                secondary: {
                  sx: { typography: 'caption', color: 'text.disabled' },
                },
              }}
            />
          </MenuItem>
        ))}
      </Scrollbar>
    </CustomPopover>
  );

  return (
    <>
      {/* {selectedContactId && (
        <AvatarGroup
          max={3}
          sx={{ [`& .${avatarGroupClasses.avatar}`]: { width: 32, height: 32 }, margin: '0 8px' }}
        >
          {data
            .filter((chat) => selectedContactId?.includes(chat.id))
            .map((contact) => (
              <Avatar key={contact.id} alt={contact.name} src={contact.avatarUrl} />
            ))}
        </AvatarGroup>
      )} */}
      <Tooltip title={t('INVITE_USER')} placement="bottom" arrow>
        <IconButton
          component={m.button}
          whileTap={varTap(0.96)}
          whileHover={varHover(1.04)}
          transition={transitionTap()}
          aria-label={t('CONTACTS_BTN')}
          onClick={handleButtonClick}
          sx={[
            (theme) => ({ ...(open && { bgcolor: theme.vars.palette.action.selected }) }),
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}
          {...other}
        >
          <Iconify icon="mingcute:user-add-2-fill" />
        </IconButton>
      </Tooltip>
      {/* {renderMenuList()} */}
    </>
  );
}
